import { CDSButton } from "@ciscodesignsystems/cds-react-button";
import { CDSCard } from "@ciscodesignsystems/cds-react-card";
import { CDSContainer } from "@ciscodesignsystems/cds-react-container";
import { CDSFlex } from "@ciscodesignsystems/cds-react-flex";
import { useNavigate } from "react-router-dom";
import { DESIGN_API, REVIEW_SPEC } from "../app/paths";

const quickActions = [
  {
    title: "Design API",
    description:
      "Define resources, operations, auth, pagination, and error handling before backend implementation.",
    ctaLabel: "Start design",
    destination: DESIGN_API,
  },
  {
    title: "Review Spec",
    description:
      "Upload or paste JSON / YAML and get governance feedback with findings, locations, and fixes.",
    ctaLabel: "Start review",
    destination: REVIEW_SPEC,
  },
];

const platformSummary = [
  { label: "Recent reviews", value: "12" },
  { label: "Active drafts", value: "4" },
  { label: "Open findings", value: "31" },
];

const suggestions = [
  "Start with Design API when the contract is still evolving.",
  "Use Review Spec for an existing OpenAPI file or generated draft.",
  "Review open findings before publishing or handing off to backend teams.",
];

const OverviewPage = () => {
  const navigate = useNavigate();

  return (
    <CDSContainer className="uag-overview-page" aria-labelledby="overview-title">
      <CDSFlex className="uag-overview-header" direction="vertical" gap={2}>
        <h1 id="overview-title">Overview</h1>
        <p className="uag-overview-subtitle">
          Build, review, and track API governance work from one workspace.
        </p>
      </CDSFlex>

      <CDSCard className="uag-overview-hero" aria-labelledby="overview-hero-title">
        <div className="uag-overview-hero-accent" aria-hidden="true" />
        <CDSFlex direction="vertical" gap={10}>
          <h2 id="overview-hero-title">Build or review API specifications in one place</h2>
          <p>
            Start with API design, generate an OpenAPI specification, then review governance
            findings.
          </p>
        </CDSFlex>
      </CDSCard>

      <CDSFlex className="uag-overview-actions" gap={24} aria-label="Overview actions">
        {quickActions.map((action) => (
          <CDSCard key={action.title} className="uag-overview-card uag-overview-action-card">
            <CDSFlex className="uag-overview-card-body" direction="vertical" gap={24}>
              <CDSFlex direction="vertical" gap={8}>
                <h2>{action.title}</h2>
                <p>{action.description}</p>
              </CDSFlex>
              <CDSButton onClick={() => navigate(action.destination)}>{action.ctaLabel}</CDSButton>
            </CDSFlex>
          </CDSCard>
        ))}
      </CDSFlex>

      <CDSFlex className="uag-overview-insights" gap={24} aria-label="Platform insights">
        <CDSCard className="uag-overview-card uag-overview-summary-card">
          <CDSFlex className="uag-overview-card-body" direction="vertical" gap={24}>
            <h2>Platform Summary</h2>
            <ul className="uag-overview-stats" aria-label="Platform summary metrics">
              {platformSummary.map((item) => (
                <li key={item.label} className="uag-overview-stat">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </li>
              ))}
            </ul>
          </CDSFlex>
        </CDSCard>

        <CDSCard className="uag-overview-card uag-overview-suggestions-card">
          <CDSFlex className="uag-overview-card-body" direction="vertical" gap={24}>
            <h2>Suggested next steps</h2>
            <ul className="uag-overview-suggestions">
              {suggestions.map((suggestion) => (
                <li key={suggestion}>{suggestion}</li>
              ))}
            </ul>
          </CDSFlex>
        </CDSCard>
      </CDSFlex>
    </CDSContainer>
  );
};

export default OverviewPage;
